import { graphql } from '~/lib/graphql'

export const CourseSelectionInfo = graphql(`
  fragment CourseSelectionInfo on Course {
    courseId
    name
    type {
      __typename
    }
    menuText
    restaurant {
      name
    }
    images {
      url
      name
    }
  }
`)
